import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import successIcon from '../../../assets/images/successIcon.svg';
import * as styles from './SuccessPage.module.css';
export const SuccessPage = () => {
    return (_jsxs("div", { className: styles.successWrapper, children: [_jsx("img", { src: successIcon, alt: 'success' }), _jsx("p", { className: styles.successTitle, children: _jsx(FormattedMessage, { id: 'successTitle' }) }), _jsx("p", { className: styles.successText, children: _jsx(FormattedMessage, { id: 'successText' }) })] }));
};
